import { render, staticRenderFns } from "./IndexIntegrationsPage.vue?vue&type=template&id=c6b4596c&"
import script from "./IndexIntegrationsPage.vue?vue&type=script&lang=js&"
export * from "./IndexIntegrationsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports